<template>
  <b-container id="dashboardInitialPortefeuilleContainer" class="mb-5 mt-5">
    <b-row>
      <div class="title">Mon portefeuille</div>
    </b-row>
    <b-row class="mt-4 mb-4">
      <div class="selectText">
        <span style="margin-right: 10px">Sélectionner une enveloppe </span>
        <select v-model="selected" class="mf_select_black" name="" id="">
          <option style="color:gray" disabled :value="[]">Enveloppe</option>
          <option v-for="(item, index) in comparisons_platforms" :key="index" :value="item.securities">{{ item.platform_contract.platform.name }} {{ item.platform_contract.contract.name }}</option>
        </select>
      </div>
    </b-row>
    <b-row>
      <div class="cardContent">
        <div class="title" v-if="selected[0]">{{ selected[0].platform_contract.contract.name }} {{ selected[0].platform_contract.platform.name }}</div>
        <b-table id="dbp-table" striped hover :fields="fields" :items="selected" :per-page="perPage" :current-page="currentPage">
          <template #head(etf)="data">
            <th class="tbHeader" style="text-align:left !important">
              <span class="tbHeader_label">{{ data.label }}</span>
            </th>
          </template>
          <template #head(score1)="data">
            <div class="tbHeader">
              <span class="tbHeader_label">{{ data.label }}</span>
            </div>
          </template>
          <template #head(score2)="data">
            <div class="tbHeader">
              <span class="tbHeader_label">{{ data.label }}</span>
            </div>
          </template>
          <template #head(portefeuille)="data">
            <div class="tbHeader">
              <span class="tbHeader_label">{{ data.label }}</span>
            </div>
          </template>
          <template #cell(titre)="data" style="text-align:left !important">
            <span class="tb_col_etf">{{ data.item.security.name }} </span>
          </template>
          <template #cell(isin)="data">
            <span class="tb_col_score">{{ data.item.security.isin }} </span>
          </template>
          <template #cell(repartition)="data">
            <span class="tb_col_score">{{ Number(data.item.amount).toFixed(0) }} </span>
          </template>
          <template #cell(decomposition)="data">
            <Modal v-if="data.item.is_lookthrough" :content="data.item.security_lookthrough" :title="data.item.security.name" />
          </template>
        </b-table>
        <b-pagination next-class="sqFirst" prev-class="sqFirst" id="dbpPagination" align="fill" v-model="currentPage" :total-rows="rows" :per-page="perPage" hide-goto-end-buttons aria-controls="dbp-table"></b-pagination>
      </div>
    </b-row>
  </b-container>
</template>
<script>
import Modal from "./Modaldecomposition.vue";
export default {
  props: ["comparisons_platforms"],
  components: {
    Modal,
  },
  data() {
    return {
      perPage: 9,
      currentPage: 1,
      form: [],
      selected: [],
      item: this.comparisons_platforms[0].securities[0],
      fields: [
        { key: "titre", label: "Vos titres" },
        { key: "isin", label: "ISIN" },
        { key: "repartition", label: "Montant (€)" },
        { key: "decomposition", label: "Décomposition" },
      ],
    };
  },
  computed: {
    rows() {
      return this.selected.length;
    },
  },
  watch: {
    selected() {
      this.currentPage = 1;
    },
  },
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#dashboardInitialPortefeuilleContainer {
  .title {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    width: 100%;
    color: $mf_ft_color_white;
    opacity: 1;
  }
  .selectText {
    text-align: left;
    font: normal normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cardContent {
    background: #242527 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    opacity: 1;
    width: 100%;
    padding: 20px;
    .title {
      text-align: center;
      font: normal normal bold $mf_ft_size_title Segoe UI;
      letter-spacing: 0px;
      color: $purple_color;
      opacity: 1;
    }
  }
  .dbpBtnLast {
    background: $purple_color 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 41px;
    opacity: 1;
    border: none;
    width: fit-content;
  }

  #dbpPagination {
    justify-content: space-between;
    height: 50px;
    background: #121212;
    border-bottom-left-radius: 33px;
    border-bottom-right-radius: 33px;
    align-items: center;

    .page-link {
      margin: 5px;
      background-color: transparent !important;
      border: none;
    }
    // .page-item.active {
    //   color: white !important;
    // }

    .page-item.disabled .page-link {
      pointer-events: none;
      background-color: transparent !important;
    }

    .page-item.active .page-link {
      background-color: $bg_color_bl !important;
      border-radius: 33px;
      color: $bg_color;
    }

    .sqFirst {
      text-align: center;
      letter-spacing: 0px;
      color: $bg_color;
      opacity: 1;
      position: relative;
    }

    li {
      button {
        border: none;
        color: $lt_grey_color;
        background: transparent !important;

        &:hover {
          background-color: transparent;
        }
        &:focus {
          border: none;
          box-shadow: none;
        }
        &:active {
          box-shadow: none;
          border: none;
        }
      }
    }
  }
  #dbp-table {
    $thRadius: 20px;
    margin-top: 20px;
    margin-bottom: 0rem !important;

    .tbHeader {
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      .tbHeader_label {
        margin-right: 15px;
      }
    }

    .table thead th {
      vertical-align: bottom;
      border: none;
    }
    thead {
      background: transparent;
    }

    th {
      background-color: #121212;
      border: none;
      color: #f5f5f5;
      text-align: center;
      padding: 15px;
    }
    th:first-child {
      border-top-left-radius: $thRadius;
    }

    th:last-child {
      border-top-right-radius: $thRadius;
    }

    tr {
      text-align: center;
      border: none;
      font: normal normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: #cacaca;
      opacity: 1;
    }
    tr:nth-child(even) {
      background-color: #121212;
      border: none;
    }
    td {
      border: none;
      padding: 10px;
    }

    li > span {
      position: relative;
      display: block;
      padding: 0.5rem 0.75rem;
      margin-left: -1px;
      line-height: 1.25;
      color: black;
      background-color: transparent !important;
      border: none !important;
      cursor: pointer;
      font-size: 20px !important;
      font-weight: bold !important;
    }
  }
}
</style>
